import React, { useState } from "react";
import { Loader2, Sparkles, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../../lib/api";

/** 'Format with AI': layout only. The server refuses any result that changed a word. */
export function AiFormatBar({ html, onApply, disabled }) {
  const [emoji, setEmoji] = useState(false);
  const [busy, setBusy] = useState(false);
  const [original, setOriginal] = useState(null);

  const run = async () => {
    setBusy(true);
    try {
      const r = await adminApi.post("/admin/marketing/format-body", { body_html: html, emoji });
      setOriginal(html);
      onApply(r.data.body_html);
      toast.success("Formatted", { description: "Your words are unchanged - only the layout moved. Undo puts it back." });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not format");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-3">
      <button onClick={run} disabled={busy || disabled} className="btn-outline-nq inline-flex items-center gap-2 px-3 py-1.5 text-xs disabled:opacity-50" data-testid="campaign-ai-format">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />}
        {busy ? "Formatting..." : "Format with AI"}
      </button>
      {original !== null && (
        <button
          onClick={() => { onApply(original); setOriginal(null); }}
          disabled={busy || disabled}
          className="btn-outline-nq inline-flex items-center gap-2 px-3 py-1.5 text-xs"
          data-testid="campaign-ai-undo"
        >
          <Undo2 className="h-3.5 w-3.5" /> Undo formatting
        </button>
      )}
      <label className="inline-flex cursor-pointer items-center gap-2 text-[11px] text-[color:var(--nq-stone)]">
        <input type="checkbox" checked={emoji} onChange={(e) => setEmoji(e.target.checked)} className="accent-[color:var(--nq-gold)]" data-testid="campaign-ai-emoji" />
        Emoji on headings
      </label>
    </div>
  );
}
